import EditBrandModelDialog from './editBrandModelDialog.container';

export default EditBrandModelDialog